export const number = value => {
	const formatted = value?.replace(',', '.');
	return Number(formatted) || '';
};
